import React, { useEffect, useState } from "react";
import "../../globalStyles/dashboardResponsive.css";
import "../../globalStyles/upcomingWebinar.css";
import "../../globalStyles/dashboardStyle.css";
import { withRouter } from "react-router-dom";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import "../../globalStyles/doctorLogin.css";
import "../../globalStyles/onBoardedDoctorLogin.scss";
import UpcomingWebinarNewRow from "./upcoming-webinar-row-new";
import { useHistory } from "react-router-dom";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

var FontAwesome = require("react-fontawesome");

const UpcomingWebinarsNew = () => {
  const [upcomingWebinarList, setupcomingWebinarList] = useState([]);
  const history = useHistory();
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  useEffect(() => {
    afterLoginApiAxios
      .post(
        "/doctor/get-upcoming-webinars",
        {
          "authorizer-principal-id": {
            user_id: userId,
          },
          doctor_id: userId,
          doctor_specialization_id: localStorage.getItem("specialization"),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((res) => {
        if (res && res.data.statusCode === 200) {
          if (
            res.data &&
            res.data.upcoming_webinar_list &&
            res.data.upcoming_webinar_list.length > 0
          ) {
            let arr = [];
            res.data.upcoming_webinar_list.map((data) => {
              if (data.is_doctor_registered === "True") {
                arr.push(data);
              }
            });
            setupcomingWebinarList(arr);
            // setupcomingWebinarList(res.data.upcoming_webinar_list);
          }
        }
      })
      .catch((error) => {
        C2CConsole.log(error.message);
      });
  }, []);

  return (
    <>
      {upcomingWebinarList?.length > 0 ? (
        <>
          <div className="container-fluid px-4 mx-0">
            {" "}
            {/**pl-0 */}
            <div className="row mb-3">
              <div className="col-12 d-flex justify-content-between align-items-baseline">
                <h2 className="mb-3">Upcoming Webinars</h2>
                <button
                  type="button"
                  class="btn btn-link apply"
                  style={{ color: "#5AD5F2" }}
                  onClick={() => history.push("/doctor/account/webinars")}
                >
                  {/* <span className="mr-1 mb-1">
                  {" "}
                  <img src={GoBack} alt="" style={{rotate:180 }}/>
                </span> */}
                  {"View All >"}
                </button>
              </div>
              <div className="up-coming-apmn px-0">
                {" "}
                {/**pl-0 */}
                <Row
                  xs={1}
                  className="patient-row-header flex-column flex-md-row align-items-center my-lg-2 border rounded-sm my-2 mx-0 text-md-left text-center spaced-titles"
                >
                  <Col
                    md={6}
                    className="flex-column align-items-center justify-content-center mb-2 mb-md-0"
                  >
                    WEBINAR TITLE
                  </Col>
                  <Col md={3} className="mb-2 mb-md-0">
                    DATE AND TIME
                  </Col>
                  <Col md={3} className="mb-2 mb-md-0">
                    ACTIONS
                  </Col>
                </Row>
                {upcomingWebinarList.length > 0
                  ? upcomingWebinarList
                      .slice(0, 3)
                      .map((webinar, index) => (
                        <UpcomingWebinarNewRow webinar={webinar} key={index} />
                      ))
                  : null}
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default withRouter(UpcomingWebinarsNew);
